import { NextPageContext, GetServerSidePropsContext } from 'next';

import type { ICommonServerSideProps } from '@belong/common-nextjs-server-side-props';

import type { INavLinkProps, ILink } from '@belong/types';
import SiteConfig from 'src/models/SiteConfig';
import CategoryModel from 'src/models/Categories';

export type SupportPageContext = NextPageContext & { config: SiteConfig };

export enum SUPPORT_PAGE_TYPE {
  article = 'article',
  category = 'category'
}

export interface ISupportPageData {
  data: any;
}

export interface ISupportPageMeta {
  pageTitle?: string;
  description?: string;
  keywords?: string;
  canonicalUrl?: string;
  pageName?: string;
  flowName?: string;
  isAuthenticatedPage?: boolean;
  journeyName?: string;
  serviceId?: string;
  noIndex?: boolean;
}

export interface ISupportPageProps extends ISupportPageData {
  statusCode?: number;
  meta?: ISupportPageMeta;
}

export interface ISupportAppProps extends ISupportPageProps {
  breadcrumbs: INavLinkProps[];
  config: SiteConfig;
}

export interface ISupportServerSidePageProps {
  meta?: ISupportPageMeta;
  data?: any;
  notFound?: boolean;
}

export interface ISupportServerAppProps extends ICommonServerSideProps {
  breadcrumbs: INavLinkProps[];
  meta?: ISupportPageMeta;
  config: SiteConfig;
  data?: any;
}

export interface IGetBreadcrumbsProps {
  path: string;
  categories: CategoryModel;
  homeLink: string | ILink;
  pageContent?: ISupportServerAppProps['data'];
}

// Function of each page to fetch specific data
export type PageServerSidePropsFunction = (
  context: GetServerSidePropsContext,
  appPropsResult: ISupportServerAppProps
) => ISupportServerSidePageProps | Promise<ISupportServerSidePageProps>;

export interface IPageError {
  statusCode: number;
}

export const isPageError = (result: any): result is IPageError => result && !!(result as IPageError).statusCode;
